import React from 'react';

const Logo = ({ 
  size = 'medium', 
  showText = true, 
  className = '', 
  variant = 'auto', // 'auto', 'dark', 'light'
  layout = 'auto', // 'auto', 'square', 'horizontal'
  onClick
}) => {
  const sizes = {
    small: { height: 32 },
    medium: { height: 48 },
    large: { height: 64 },
    xlarge: { height: 120 }
  };

  const currentSize = typeof size === 'number' 
    ? { height: size } 
    : (sizes[size] || sizes.medium);

  // Determine which logo to use based on size and context
  const getLogoSrc = () => {
    // For very small sizes, use square logos
    const useSquare = size === 'small' || layout === 'square' || (!showText && layout !== 'horizontal');
    
    // Auto-detect variant based on context (default to white for visibility)
    let colorVariant = 'white';
    if (variant === 'dark') {
      colorVariant = 'black';
    } else if (variant === 'light') {
      colorVariant = 'white';
    }
    
    // Choose the appropriate logo file
    if (useSquare) {
      if (showText) {
        return `/new-Logo-${colorVariant}-square-text.png`;
      } else {
        return `/new-logo-${colorVariant}.jpg`;
      }
    } else {
      // Use horizontal layout for larger sizes with text
      return `/new-logo-${colorVariant}-horizontal.jpg`;
    }
  };

  const logoSrc = getLogoSrc();

  return (
    <div 
      className={`logo ${className}`} 
      style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default'
      }}
      onClick={onClick}
    >
      <img
        src={logoSrc}
        alt="RentalHelp.ai"
        style={{
          height: currentSize.height,
          width: 'auto',
          maxWidth: '100%',
          objectFit: 'contain'
        }}
        onError={(e) => {
          // Fallback to white version if black version fails to load
          if (e.target.src.includes('black')) {
            e.target.src = e.target.src.replace('black', 'white');
          }
        }}
      />
    </div>
  );
};

export default Logo; 